import React, { useState, useEffect } from 'react';
import f3 from '../../assets/images/f3-removebg-preview.png';
import { NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const isHome = location.pathname === '/';

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        if (isHome) {
            const handleScroll = () => {
                setScrolled(window.scrollY > 50);
            };
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        } else {
            setScrolled(true); // always solid on other pages
        }
    }, [isHome]);

    return (
        <header
            className={`${isHome ? (scrolled ? 'bg-indigo-900 shadow-md' : 'bg-transparent') : 'bg-indigo-900 shadow-md'} p-4 lg:p-5 z-10 fixed top-0 left-0 w-full transition-colors duration-300`}
        >
            <nav className="flex justify-between items-center max-w-15xl mx-auto">
                <div className="flex items-center">
                    <img src={f3} alt="YEW logo" className="h-20" />
                    <div className="ml-2">
                    </div>
                </div>
                <div
                    className={`lg:flex lg:items-center ${isMenuOpen ? 'block' : 'hidden'
                        } absolute top-full left-0 bg-white w-full py-4 lg:py-0 lg:bg-transparent lg:relative lg:static lg:flex lg:justify-end lg:pt-0 lg:top-auto lg:left-auto`}
                >
                    <NavLink
                        to="/"
                        className="text-indigo-800 m:text-white lg:text-white font-bold hover:text-indigo-500 transition duration-300 block lg:inline-block lg:mx-4 mb-4 text-xs lg:text-sm pl-2"
                    >
                        Home
                    </NavLink>
                    <NavLink
                        to="/about"
                        className="text-indigo-800 m:text-white lg:text-white font-bold hover:text-indigo-500 transition duration-300 block lg:inline-block lg:mx-4 mb-4 text-xs lg:text-sm pl-2"
                    >
                        About
                    </NavLink>
                    <NavLink
                        to="/projects"
                        className="text-indigo-800 m:text-white lg:text-white font-bold hover:text-indigo-500 transition duration-300 block lg:inline-block lg:mx-4 mb-4 text-xs lg:text-sm pl-2"
                    >
                        Projects
                    </NavLink>
                    <a
                        href="mailto:info@dzikoccj.org?subject=Inquiry%20from%20Website&body=Hello%20Dziko%20CCJ%20Team%2C%0D%0A%0D%0AI%20would%20like%20to%20know%20more%20about..."
                        className="text-indigo-800 m:text-white lg:text-white font-bold hover:text-indigo-500 transition duration-300 block lg:inline-block lg:mx-4 mb-4 text-xs lg:text-sm pl-2"
                    >
                        Contact
                    </a>
                    <NavLink
                        to="/support"
                        className="text-indigo-800 m:text-white lg:text-white font-bold hover:text-indigo-500 transition duration-300 block lg:inline-block lg:mx-4 mb-4 text-xs lg:text-sm pl-2"
                    >
                        Support Us
                    </NavLink>
                </div>
                <button
                    className="lg:hidden ml-2 mt-2 text-white"
                    onClick={toggleMenu}
                >
                    ☰
                </button>
            </nav>
        </header>
    );
};

export default Navbar;
